var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'invisible_link' + _vm.item.id,staticClass:"invisible_link",on:{"click":_vm.linkClicked}})}
var staticRenderFns = []

export { render, staticRenderFns }